import { RecordedSessionsPage } from "./RecordedSessionsPage";

/** Existing source links open the source step of Conversations. */
export function WorkspaceRecordPage() {
  return <RecordedSessionsPage />;
}
